/**
 * Cleans noise from Apollo mutation/query error messages
 *
 * Example: '[GraphQL Error]: In field "createUser": SomeError' to 'SomeError'
 **/
export const cleanApolloErrorMessage = (errorMessage: string): string =>
  errorMessage.replace(/GraphQL Error: In field ".+":\s/gi, "");
